export enum StoreKey {
    // Add the Store Keys below
    SelectedMenuTabState,
    SelectedProductCategory,
    ProductCategorySuccess,
    UserDetails,
    SelectedProduct,
    ProductCategoryGridState,
    SelectedProductAdditionalField,
    ProductAdditionalFieldSuccess,
    ProductSuccessMessage,
    AvailableQuotations,
    ProductGridState,
    UserPermission,
    SampleAdditionalFieldGridState,
    SelectedAccount,
    ActiveProductCategories,
    ImportedProducts,
    ListValuesDictionary
}
